import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG } from '@cco-apps/cco-frontend';
import { DialRequest } from '@app/core/models/dial-request';
import { SmsRequest } from '@app/core/models/sms-request';
import { Observable } from 'rxjs';

@Injectable()
export class TelephonyService {
  private http = inject(HttpClient);

  protected readonly baseUrl: string;

  constructor() {
    const config = inject(APP_CONFIG);

    this.baseUrl = `${config.apiBaseUrl}/telephony`;
  }

  dial(dialRequest: DialRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}/dial`, dialRequest, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'text',
    });
  }

  sendSms(smsRequest: SmsRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}/sms`, smsRequest, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'text',
    });
  }
}
